export let ETestModalPages=function(ETestModalPages){ETestModalPages["TestSimpleModal"]="TestSimpleModal";return ETestModalPages;}({});